import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { OccEndpointsService } from '@spartacus/core'
import { Observable } from 'rxjs'
import {MatomoIds} from "../../interface/eb-matomo-id.interface";

@Injectable({ providedIn: 'root' })
export class EbAnalyticsAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService
  ) {}

  public getAnalyticsSystemId(): Observable<MatomoIds> {
    return this.http.get<MatomoIds>(this.occEndpointsService.buildUrl('analytics'))
  }
}
